// ============================================================================
// L'EXPORT CSV « Excel FR » — la mécanique partagée des boutons « Export Excel ».
//
// UTILITÉ : chaque écran nomme ses colonnes et ses valeurs ; ICI vivent les trois décisions qui
// faisaient déjà l'unanimité dans les trois copies existantes (écarts, mouvements, stock — règle de
// 2 dépassée au 4ᵉ consommateur, Rétrocessions) : séparateur `;` et BOM UTF-8 pour qu'Excel FR ouvre
// le fichier proprement, guillemets échappés, nom de fichier daté.
//
// ⚠️ LES VALEURS SONT DES CHAÎNES DÉJÀ FORMATÉES par l'écran (dates fr, montants à virgule) : ce
// module ne connaît ni l'argent ni les dates — les formater ici recréerait une seconde définition à
// côté de celle des écrans.
// ============================================================================

/** Une cellule : chaîne ou nombre — `null`/`undefined` deviennent la cellule vide. */
export type CelluleCsv = string | number | null | undefined;

/** Le début d'une cellule qu'un tableur lirait comme une FORMULE. */
const FORMULA_START = /^[=+\-@\t\r]/;
/** Un nombre écrit tel quel (« -12,50 », « 1234 ») — il commence par un signe sans être une formule. */
const PLAIN_NUMBER = /^[+-]?\d+(?:[.,]\d+)?$/;

/**
 * Une cellule du fichier, entre guillemets (échappés) — un libellé d'article contient des `;` et des retours à la ligne
 * plus souvent qu'on ne le croit.
 * ⚠️ UNE CELLULE QUI COMMENCE COMME UNE FORMULE (`=`, `+`, `-`, `@`, tabulation, retour chariot) REÇOIT UNE APOSTROPHE EN
 *    TÊTE : un tableur l'exécuterait à l'ouverture, et un nom de marque ou de fournisseur venu de l'EDI ou d'un import peut
 *    en porter une. Un NOMBRE négatif n'en est pas une et reste tel quel — sinon le tableur le lirait comme du texte.
 */
export function csvCell(v: CelluleCsv): string {
  const text = String(v ?? '');
  const safe = FORMULA_START.test(text) && !PLAIN_NUMBER.test(text) ? `'${text}` : text;
  return `"${safe.replace(/"/g, '""')}"`;
}

/** Compose et TÉLÉCHARGE le fichier — `<prefixe>-<AAAA-MM-JJ>.csv`. */
export function exporterCsv(prefixe: string, headers: readonly string[], lines: readonly (readonly CelluleCsv[])[]): void {
  const contenu = [headers.map(csvCell).join(';'), ...lines.map((l) => l.map(csvCell).join(';'))].join('\r\n');
  const url = URL.createObjectURL(new Blob(['\uFEFF' + contenu], { type: 'text/csv;charset=utf-8' }));
  const a = document.createElement('a');
  a.href = url;
  a.download = `${prefixe}-${new Date().toISOString().slice(0, 10)}.csv`;
  a.click();
  window.setTimeout(() => URL.revokeObjectURL(url), 4000);
}
